module.exports = __webpack_public_path__ + "static/media/UNN-removebg-preview (1).a7c8a9df.png";